// dom content loaded
document.addEventListener("DOMContentLoaded", function () {
  // initialize modal library
  function initModal() {
    setTimeout(() => {
      MicroModal.init({
        onShow: (modal) => {
          const { productData } = window.tinderbox;
          // get the selected variant id from the url, variant param
          const selectedVariantId =
            new URLSearchParams(window.location.search).get("variant") ||
            productData.variants[0].id;

          const selectedVariant = productData.variants.find(
            (variant) => Number(variant.id) === Number(selectedVariantId)
          );

          if (selectedVariant) {
            //set the product name on modal and form hidden field
            document.querySelector(
              "#bulk-inquiry-modal [data-selected-variant-name]"
            ).textContent = selectedVariant.name;
            document.querySelector(
              "#ContactForm-bulk-order-inquiry-form [name='contact[product_variant_name]']"
            ).value = selectedVariant.name;
            const variantImage = selectedVariant?.featured_image?.src;
            if (variantImage) {
              const productImage = document.querySelector(
                ".inquiry-modal__product-info img"
              );
              productImage.src = variantImage;
              productImage.srcset = variantImage + "&width=100 100w";
            }
          }
        },
        openTrigger: "data-inquiry-modal-open",
        disableScroll: true,
        disableFocus: false,
        awaitOpenAnimation: false,
        awaitCloseAnimation: false,
        debugMode: true,
      });
    }, 500);
  }

  initModal();
  document.addEventListener("variant:change", initModal);

  // on page load, if the url contains ?contact_posted=true parameter then show the success modal
  if (window.location.search.includes("contact_posted=true")) {
    MicroModal.show("bulk-inquiry-success-modal");
  }

  // MicroModal.show("bulk-inquiry-modal"); // for testing - always launch modal on page load

  flatpickr("#delivery-date", {
    position: "above",
    altInput: true,
    altFormat: "F j, Y",
    dateFormat: "Y-m-d",
    required: true,
    allowInput: true,
    minDate: "today",
  });
});
